export const AlignMiddleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="none">
    <path
      d="M4.66683 14V8.66667H1.3335V7.33333H4.66683V2H6.66683V7.33333H9.3335V4H11.3335V7.33333H14.6668V8.66667H11.3335V12H9.3335V8.66667H6.66683V14H4.66683Z"
      fill="currentColor"
    />
  </svg>
);
